import React, {useRef, useCallback, useState, useMemo} from 'react';
import Icons from '../../../assets/svgs/icons';

const style = {
  camera: {
    display: 'none',
  },
  wrapper: {
    height: '12rem',
    borderRadius: '1rem',
    background: 'white',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
};

const Camera = ({icon, title, onPhotoTaken, pdf = false, capture = 'environment'}) => {
  const ref = useRef(null);
  const [data, setData] = useState({});
  const reader = useMemo(() => new FileReader(), []);

  const onCapture = useCallback(async () => {
    const file = ref.current.files[0];

    if (!!file) {
      onPhotoTaken(file);
      if (file.type === 'application/pdf') {
        setData({type: 'pdf', name: file.name});
      } else {
        const uri = await new Promise((res) => {
          reader.onload = () => res(reader.result);
          reader.readAsDataURL(file);
        });
        setData({uri, type: 'img'});
      }
    }
  }, [reader, onPhotoTaken]);

  return (
    <>
      <input
        ref={ref}
        type="file"
        name="image"
        capture={capture}
        style={style.camera}
        onChange={onCapture}
        accept={pdf ? 'image/*,application/pdf' : 'image/*'}
      />
      <div
        style={style.wrapper}
        onClick={() => ref.current.click()}
        className="d-flex flex-column align-items-center justify-content-between border p-3">
        {{
          img: data.uri?.length > 0 && <img src={data.uri} style={style.image} alt="foto selecionada pelo input" />,
          pdf: data.name?.length > 0 && (
            <div className="my-auto d-flex align-items-center">
              <Icons name="pdf" size="3rem" />
              <span className="text-muted pl-2">{data.name}</span>
            </div>
          ),
        }[data.type] ?? (
          <>
            <span className="font-weight-bold text-muted">{title}</span>

            <Icons name={icon} size="40%" className="my-3" />

            <small className="text-muted">Toque para abrir a câmera</small>
          </>
        )}
      </div>
    </>
  );
};

export default React.memo(Camera);
